module.exports = __webpack_public_path__ + "static/img/continuous_playback_stop.3f3b730.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/continuous_playback_stop.png
// module id = LECA
// module chunks = 1